import { isString } from 'angular';
var CaptchaController = (function () {
    function CaptchaController(vcRecaptchaService, $q) {
        this.vcRecaptchaService = vcRecaptchaService;
        this.$q = $q;
    }
    CaptchaController.prototype.reCaptchaSetResponse = function (response) {
        this.reCaptchaResponse = response;
    };
    CaptchaController.prototype.reCaptchaSetWidgetId = function (widgetId) {
        this.reCaptchaWidgetId = widgetId;
    };
    CaptchaController.prototype.reCaptchaExpiration = function () {
        this.vcRecaptchaService.reload(this.reCaptchaWidgetId);
        this.reCaptchaResponse = null;
    };
    CaptchaController.prototype.getCaptchaModel = function () {
        var model = {};
        if (isString(this.reCaptchaResponse) && this.reCaptchaResponse !== '') {
            model.responseToken = this.reCaptchaResponse;
        }
        else {
            model.result = {
                id: this.simpleMathId,
                userResult: this.simpleMathUserResult,
            };
        }
        return model;
    };
    CaptchaController.prototype.checkGoogleAccessibility = function () {
        var deferred = this.$q.defer();
        var image = new Image();
        image.onload = function () {
            deferred.resolve();
        };
        image.onerror = function () {
            deferred.reject();
        };
        image.src = '//google.com/favicon.ico';
        return deferred.promise;
    };
    return CaptchaController;
}());
export { CaptchaController };
